import { types, actions } from './requests'
export const GETMATERIALLIST_TYPES = {
    ...types('GETMATERIALLIST'),
}
export const GETMATERIALLIST_ACTIONS = {
    ...actions('GETMATERIALLIST'),
}